// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2b80Q","consentsList":"PatientConsents_consentsList__1hxpp","consentsListEmpty":"PatientConsents_consentsListEmpty__3k7Eu"};